import isNotNil from './isNotNil';

const checkLimit = (limit: number | undefined | null, lengthOfList: number) => (
  isNotNil(limit) ? limit > lengthOfList : true
);

export default checkLimit;
